<template>
  <non-property-layout>
    <h1 class="text-xl font-bold py-6">Choose Property:</h1>
    <div
      v-for="portalListDto in portals"
      :key="portalListDto.portalId"
      class="py-3 pl-4 hover:bg-blue-200"
    >
      <router-link
        class="text-blue-800 w-full text-lg"
        :to="`/${portalListDto.siteCode}/externalregister?token=${userGuid}&client=${client}&authtoken=${urlToken}`"
        >{{ portalListDto.name }}</router-link
      >
    </div>
  </non-property-layout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";

const bldgStore = useBldgStore();
const userStore = useUserStore();
const router = useRouter();

let user = computed(() => userStore.user);
let userGuid = ref("");
let urlToken = ref("");
let client = ref("");

var portals = computed(() => bldgStore.portalList);

onMounted(loadData);
watch(user, loadData);

const isUserLoading = ref(false);

async function loadData() {
  isUserLoading.value = true;
  urlToken.value = router.currentRoute?.value?.query?.t.toString();
  if (urlToken.value) {
    userStore.setAuthToken(urlToken.value);
  }

  let userIdarr = router.currentRoute?.value?.query?.token ?? null;
  let userId = Array.isArray(userIdarr) ? userIdarr[0] : userIdarr;
  if (!userId) {
    console.error("Pass userId token for sso logged in user");
  }
  userGuid.value = userId;

  console.log("Sso Portal List page loading data for user: " + userId);
  let clientNameArr = router.currentRoute?.value?.query.client ?? null;
  let clientName = Array.isArray(clientNameArr) ? clientNameArr[0] : clientNameArr;
  if (clientName?.length > 0) {
    client.value = clientName;
    await bldgStore.getPortalList(clientName);
  }

  isUserLoading.value = false;
}
</script>
